export default "__VITE_ASSET__brQts8UH__"